<template>
  <!-- 多行移除ie暂不支持 -->
  <el-tooltip ref="tooltip" :open-delay="360" effect="light" :disabled="!tooltip" enterable :content="tooltipContent" placement="top">
    <div ref="textBoxWrap" class="textOverflow multiLine" :style="textOverflowStyle" @mouseenter="mouseEnter">
      <slot />
    </div>
  </el-tooltip>
</template>

<script>
const isIE = function () {
  return !isNaN(Number(document.documentMode));
};

function debounce(fn, time) {
  let timeout = null
  return function (e) {
    clearTimeout(timeout)
    timeout = setTimeout(() => {
      fn.call(this, e)
    }, time)
  }
}
export default {
  name: 'TextOverflow',
  props: {
    lines: {
      type: String,
      default: '1'
    },
    width: {
      type: String
    },
    fontSize: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tooltipMaxTxt: {
      type: String,
      default: 'Infinity'
    }
  },
  data() {
    return {
      tooltip: false,
      tooltipContent: '',
    }
  },
  computed: {
    textOverflowStyle() {
      return {
        width: this.width,
        fontSize: this.fontSize,
        '-webkit-line-clamp': this.lines ? this.lines : 1,
        '-webkit-box-orient': 'vertical'
      }
    }
  },
  methods: {
    mouseEnter() {
      if (this.disabled) return
      const dom = this.$refs.textBoxWrap
      // 如果dom不存在则不执行后面逻辑 snl
      if (!dom) return
      // 获取渲染元素
      const range = document.createRange()
      range.setStart(dom, 0)
      range.setEnd(dom, dom.childNodes.length)
      const rangeRect = range.getBoundingClientRect()
      const domRect = dom.getBoundingClientRect()
      const rangeWidth = Math.floor(rangeRect.width)
      // ie 补充4像素
      const domWidth = Math.floor(domRect.width) + (isIE() ? 4 : 0)
      const rangeHeight = Math.floor(rangeRect.height)
      const domHeight = Math.floor(domRect.height)
      const show = () => {
        this.tooltip = true
        // 添加tootip内容 设置tootip渲染
        this.tooltipContent = dom.innerText || dom.textContent
        const tooltip = this.$refs.tooltip
        tooltip.referenceElm = dom

        // tooltip上最多的文字限制
        if (this.tooltipMaxTxt !== 'Infinity') {
          if (this.tooltipMaxTxt < this.tooltipContent.length) {
            this.tooltipContent = this.tooltipContent.slice(0, this.tooltipMaxTxt) + '...'
          }
        }
      }

      // 单行溢出 ie 需要 dom.scrollWidth <= dom.offsetWidth 来对比
      if (rangeHeight <= domHeight && rangeWidth <= domWidth && dom.scrollWidth <= (dom.offsetWidth + (isIE() ? 1 : 0))) {
        this.tooltip = false
      } else if (this.lines !== '1' && rangeHeight <= domHeight) {
        this.tooltip = false
      } else {
        show()
      }
    }
  }
}
</script>

<style scoped lang="scss">
.textOverflow {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.multiLine {
  display: -webkit-box;
  white-space: unset;
  -webkit-box-orient: vertical;
}
</style>
